// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// reports
export const environment = {
  production: false,

  firebase: {
    apiKey: 'AIzaSyA0ZpEM3fBtOpYbrbWz6ubbR2JfjfXoQvA',
    authDomain: 'bimboakiba.firebaseapp.com',
    databaseURL: 'https://bimboakiba.firebaseio.com',
    projectId: 'bimboakiba',
    storageBucket: 'bimboakiba.appspot.com',
    messagingSenderId: '903461873271',
    appId: '1:903461873271:web:f1e79ad2b16d8e68'
  },

  firebaseDev: {
    apiKey: "AIzaSyAZKoeiOEvUACTvQ54JfCBjXRPPGiT_zag",
    authDomain: "bimboakiba-dev.firebaseapp.com",
    databaseURL: "https://bimboakiba-dev.firebaseio.com",
    projectId: "bimboakiba-dev",
    storageBucket: "bimboakiba-dev.appspot.com",
    messagingSenderId: "1039309708923",
    appId: "1:1039309708923:web:98e95919a7641fc03f4cde"
  },

  OAuthSettings: {
    appId: 'b86eadb7-c515-4ee4-85ff-ece64afd2145',
    redirectUri: 'https://bimboakiba.web.app/ssoauth',
    authority: 'https://login.microsoftonline.com/973ba820-4a58-4246-84bf-170e50b3152a',
    cacheLocation: 'localStorage',
    protectedResourceMap: [['https://graph.microsoft.com/v1.0/me', ['user.read']]],
    popUp: false,
    navigateToLoginRequestUrl: false,
    scopes: [
      'user.read',
    ]
  },

  instantSearchKeys: {
    appId: 'QLNIGF7LAV',
    apiKey: '824256d525cd76501994b38c8d1880cb',
    indexName: 'bimbodev',
    urlSync: false,
    searchParameters: {
      facets: ['company', 'supervisor']
    }
  },

  sidebarRoutes: {
    akiba: {
      tabs: [
        {
          path: '/akiba/employee-list',
          title: 'Lista De<br>Colaboradores',
          icon: 'list',
          visible: true
        },
        {
          path: '/akiba/employee-list',
          title: 'Detalle De <br>Colaborador',
          icon: 'accessibility',
          visible: false
        },
        { divider: true },
        {
          path: '/akiba/pending-requests',
          title: 'Préstamos Pendientes',
          icon: 'timer',
          visible: true
        },
        { divider: true },
        {
          path: '/akiba/permanent-saving-parameters',
          title: 'Parámetros Caja De <br>Ahorro Permanente',
          icon: 'account_balance',
          visible: true
        },
        {
          path: '/akiba/permanent-savings-loan-parameters',
          title: 'Parámetros Préstamos Caja de<br>Ahorro Permanente',
          icon: 'assignment',
          visible: true
        },
        {
          path: '/akiba/permanent-installment-parameters',
          title: 'Parámetros Recuperación<br>de Préstamos',
          icon: 'credit_card',
          visible: true
        },
        {
          path: '/akiba/saving-investments',
          title: 'Inversión Caja<br>De Ahorro',
          icon: 'chrome_reader_mode',
          visible: true
        },
        { divider: true },
        {
          path: '/akiba/retirement-saving-parameters',
          title: 'Parámetros Caja De <br>Ahorro Retiro',
          icon: 'account_balance',
          visible: true
        },
        {
          path: '/akiba/retirement-savings-loan-parameters',
          title: 'Parámetros Préstamos Caja de<br>Ahorro Retiro',
          icon: 'assignment',
          visible: true
        },
        {
          path: '/akiba/share-saving-parameters',
          title: 'Parámetros Ahorro<br>Por Acciones',
          icon: 'monetization_on',
          visible: true
        },
        { divider: true },
        {
          path: '/akiba/saving-fund',
          title: 'Parámetros<br>De Fondos',
          icon: 'assignment',
          visible: true
        },
        { divider: true },
        {
          path: '/akiba/pending-list-parameters',
          title: 'Parámetros<br>Lista de Espera ',
          icon: 'list',
          visible: true
        },
        { divider: true },
        {
          path: '/akiba/payroll-dates',
          title: 'Candados Fechas<br>De Pagos',
          icon: 'lock_outline',
          visible: true
        },
        { divider: true },
        {
          path: '/akiba/share-saving',
          title: 'Ahorro<br>Por Acciones',
          icon: 'monetization_on',
          visible: true
        },
        {
          path: '/administrator/share-saving-aproval',
          title: 'Aprobación Carta Compromiso<br>Por Acciones',
          icon: 'assignment_turned_in',
          visible: true
        },
        {
          path: '/akiba/veab-registration',
          title: 'Bono VEAB',
          icon: 'monetization_on',
          visible: true
        },
        { divider: true }
      ],
      menus: [
        { path: '/supervisor', title: 'Supervisor', claimLevel: 2 },
        { path: '/administrator', title: 'Administrador', claimLevel: 3 },
        { path: '/akiba', title: 'Akiba', claimLevel: 4 }
      ]
    },
    administrator: {
      tabs: [
        {
          path: '/administrator/employee-list',
          title: 'Lista De <br>Colaboradores',
          icon: 'list',
          visible: true
        },
        {
          path: '/administrator/employee-list',
          title: 'Regresar a<br>Lista',
          icon: 'accessibility',
          visible: false
        },
        { divider: true },
        {
          path: '/administrator/pending-requests',
          title: 'Préstamos Pendientes',
          icon: 'timer',
          visible: true
        },
        {
          path: '/administrator/loans-waiting-list',
          title: 'Prestamos En<br>Lista De Espera',
          icon: 'access_time',
          visible: true
        },
        { divider: true },
        {
          path: '/administrator/reports',
          title: 'Reporte De<br> Movimientos',
          icon: 'sync',
          visible: true
        },
        { divider: true },
        {
          path: '/administrator/permanent-saving-parameters',
          title: 'Parámetros Caja De <br>Ahorro Permanente',
          icon: 'account_balance',
          visible: true
        },
        {
          path: '/administrator/permanent-savings-loan-parameters',
          title: 'Parámetros Préstamos Caja de<br>Ahorro Permanente',
          icon: 'assignment',
          visible: true
        },
        {
          path: '/administrator/retirement-saving-parameters',
          title: 'Parámetros Caja De <br>Ahorro Retiro',
          icon: 'account_balance',
          visible: true
        },
        {
          path: '/administrator/retirement-savings-loan-parameters',
          title: 'Parámetros Préstamos Caja de<br>Ahorro Retiro',
          icon: 'assignment',
          visible: true
        },
        { divider: true },
        {
          path: '/administrator/permanent-installment-parameters',
          title: 'Parámetros Recuperación<br>de Préstamos',
          icon: 'credit_card',
          visible: true
        },
        {
          path: '/administrator/pending-list-parameters',
          title: 'Parámetros<br>Lista de Espera ',
          icon: 'list',
          visible: true
        },
        {
          path: '/administrator/saving-fund',
          title: 'Parámetros<br>De Fondos',
          icon: 'assignment',
          visible: true
        },
        {
          path: '/administrator/share-saving-parameters',
          title: 'Parámetros Ahorro<br>Por Acciones',
          icon: 'monetization_on',
          visible: true
        },
        { divider: true },
        {
          path: '/administrator/saving-investments',
          title: 'Inversión Caja<br>De Ahorro',
          icon: 'chrome_reader_mode',
          visible: true
        },
        {
          path: '/administrator/payroll-dates',
          title: 'Candados Fechas<br>De Pagos',
          icon: 'lock_outline',
          visible: true
        },
        { divider: true },
        {
          path: '/administrator/share-saving',
          title: 'Ahorro<br>Por Acciones',
          icon: 'monetization_on',
          visible: true
        },
        {
          path: '/administrator/share-saving-aproval',
          title: 'Aprobación Carta Compromiso<br>Por Acciones',
          icon: 'assignment_turned_in',
          visible: true
        },
        {
          path: '/administrator/veab-bonus',
          title: 'Bono VEAB',
          icon: 'monetization_on',
          visible: true
        },
        { divider: true }
      ],
      menus: [
        { path: '/employee', title: 'Colaborador', claimLevel: 1 },
        { path: '/supervisor', title: 'Supervisor', claimLevel: 2 },
        { path: '/administrator', title: 'Administrador', claimLevel: 3 }
      ]
    },
    supervisor: {
      tabs: [
        {
          path: '/supervisor/employee-list',
          title: 'Lista De <br>Colaboradores',
          icon: 'list',
          visible: true
        },
        {
          path: '/supervisor/employee-list',
          title: 'Detalle De <br>Colaborador',
          icon: 'accessibility',
          visible: false
        },
        {
          path: '/supervisor/pending-requests',
          title: 'Préstamos Pendientes',
          icon: 'timer',
          visible: true
        },
      ],
      menus: [
        { path: '/employee', title: 'Colaborador', claimLevel: 1 },
        { path: '/supervisor', title: 'Supervisor', claimLevel: 2 }
      ]
    },
    employee: {
      tabs: [
        {
          path: '/employee/home',
          title: 'Finanzas',
          icon: 'list',
          visible: true
        },
        {
          path: '/employee/profile',
          title: 'Perfil',
          icon: 'accessibility',
          visible: true
        }
      ],
      menus: [
        { path: '/employee', title: 'Colaborador', claimLevel: 1 }
      ]
    }
  },

  images: {
    states: {
      normal: {
        caja: 'assets/img/caja.svg',
        prestamos: 'assets/img/prestamo.svg',
        fondo: 'assets/img/fondo.svg',
        general: 'assets/img/general.svg',
        laboral: 'assets/img/laboral.svg'
      },
      selected: {
        caja: 'assets/img/caja_filled.svg',
        prestamos: 'assets/img/prestamo_filled.svg',
        fondo: 'assets/img/fondo_filled.svg',
        general: 'assets/img/general_filled.svg',
        laboral: 'assets/img/laboral_filled.svg'
      },
      unselected: {
        caja: 'assets/img/caja_outlined.svg',
        prestamos: 'assets/img/prestamo_outlined.svg',
        fondo: 'assets/img/fondo_outlined.svg',
        general: 'assets/img/general_outlined.svg',
        laboral: 'assets/img/laboral_outlined.svg'
      }
    }
  },

  variableLoan: true,

  version: require('../../../../package.json').version

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
